import type {
    AttributeDefinitionDraft,
    FieldDefinition,
    ProductTypeDraft,
    TypeDraft,
} from '@commercetools/platform-sdk';

export function fixAttributes<T extends FieldDefinition | AttributeDefinitionDraft>(definitions?: T[]): T[] {
    return (definitions ?? []).map(definition => ({
        ...definition,
        // Making sure inputHint gets a 'SingleLine' as default value as it is required by the ‘syncTypes.buildActions’
        inputHint: definition.inputHint ?? 'SingleLine',
    }));
}

export function convertToComparableProductTypeDraft(productTypeDraft: ProductTypeDraft): ProductTypeDraft {
    const { attributes } = productTypeDraft;
    return {
        ...productTypeDraft,
        attributes: fixAttributes(attributes),
    };
}

export function convertToComparableTypeDraft(typeDraft: TypeDraft): TypeDraft {
    const { fieldDefinitions } = typeDraft;
    return {
        ...typeDraft,
        fieldDefinitions: fixAttributes(fieldDefinitions),
    };
}
